module.exports = __webpack_public_path__ + "media/images/captive_portal/router2-a1138513f297bcbf1563b02299bff36d.png";